'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./hqo-theme-79db6cc8.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-89b3b361.js');
require('./form-field-8601b6d9.js');
require('./enums-de2d9d36.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./index-c3c373ce.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-8f6b1e8c.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-0cb3d1f5.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-57cc71fd.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');
require('./styles-e0000262.js');
require('./styles-4cf0a0ea.js');
require('./calendar-header-9cff0d7c.js');
require('./component-ac1f77a8.js');
require('./styles-f5c78667.js');
require('./back-link-0ede7a09.js');
require('./styles-b45e911a.js');
require('./styles-d2f31ec6.js');
require('./constants-1c2e2b2b.js');
require('./button-group-de5cad34.js');
require('./button-with-options-c354df43.js');
require('./popover-09eb9e01.js');
require('./calendar-view.styles-be23bcc4.js');
require('./day-labels.styles-152dcd41.js');
require('./day-view.styles-70924b35.js');
require('./days-view.styles-ea58f0e4.js');
require('./buttons-view.styles-d5df4293.js');
require('./styles-1ad7f6ad.js');
require('./checkbox-hqo-d946369c.js');
require('./empty-state-4520e4db.js');
require('./menu-item-dfcda6d2.js');
require('./chip-dropdown-dcd971c2.js');
require('./styles-00533d56.js');
require('./contentBlock-ece87f53.js');
require('./component-294e2694.js');
require('moment');
require('./date-input-title-93b678c0.js');
require('./date-input-container-aa5e7951.js');
require('./component-5bca3e99.js');
require('./drawer-section-2084bccb.js');
require('./dropdown-3f4ce7bb.js');
require('react-dom');
require('./empty-state-v2-d7131509.js');
require('./notification.styles-9c4c6136.js');
require('./file-block-d6c87493.js');
require('./form-group-10ed42fe.js');
require('./component-e4455c39.js');
require('./calendar-wrapper.styles-5423cc8e.js');
require('./calendar-field.styles-5f11b2de.js');
require('./styles-64b3a95d.js');
require('./hqo-multiselect-chips-4c8820d7.js');
require('./hqo-visible-select-2ba14aa8.js');
require('./styles-9361fa87.js');
require('./image-upload-08bc5199.js');
require('./image-upload-fa0fd2dd.js');
require('./index.esm-055407fd.js');
require('./international-phone-input-form-09c1abb0.js');
var component$j = require('./component-e78ef5af.js');
require('./styles-20b982bf.js');
require('./styles-9077e262.js');
require('./modal-a8c021a3.js');
require('./modal-61e0272d.js');
require('./component-a169b61c.js');
require('./component-0d3539a5.js');
require('./styles-56d6022d.js');
require('./close-button-d86113f6.js');
require('./component-cb2dd1a0.js');
require('./styles-8d4a3ad6.js');
require('./errorModal-d7ff3a41.js');
require('./component-f67d65a6.js');
require('./styled-245d62c9.js');
require('./dropdown.component-ed2bfb9e.js');
require('./menu.component-cc597d8a.js');
require('./title.component-1027cd5c.js');
require('./styles-0ce12bea.js');
require('./cell-96115b74.js');
require('./new-table-2511f14f.js');
require('./sortable-header-4cd0bb4d.js');
require('./styles-8735da64.js');
require('./component-1a70d4e9.js');
require('./pin-input-15ae64b6.js');
require('./progress-bar-cfb02ff8.js');
require('./styles-75870089.js');
require('./radio-button-6df8baa3.js');
require('./radio-button-group-cdc27831.js');
require('./styles-4a4d0f0b.js');
require('./rating-cf21e095.js');
require('./styles-d009fda4.js');
require('./component-3b498127.js');
require('./kebabCase-b150ced7.js');
require('./styles-fb2a64c7.js');
require('./component.styles-89fe8ebe.js');
require('./styles-b3bf24d6.js');
require('./styles-66ea8e11.js');
require('./small-footer-945a9c24.js');
require('./component-a4dabdc0.js');
require('./component-131d3a6b.js');
require('./switch-b3594efa.js');
require('./tab-7d963d53.js');
require('./styles-4efe67ee.js');
require('./themeProvider-842e31f2.js');
require('./time-picker-7099b0c7.js');
require('./time-wrapper.styles-304fa538.js');
require('./time-picker-input.styles-2c771083.js');
require('moment-timezone');
require('./component.styles-9bb0eef7.js');
require('./component.styles-d0eee7a8.js');
require('./styles-8071793d.js');
require('./component-a0032a3a.js');
require('./component.styles-cd2da23e.js');
require('./menu-ec58171a.js');
require('./styles-23854021.js');
require('./styles-2048c729.js');
require('./styles-6845ded1.js');
require('./styles-6941c479.js');
require('./search-input-v2-constants-f31caee4.js');
require('./styles-5b72d46e.js');
require('./pagination-7ad19776.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  margin-top: 29px;\n\n  @media only screen and (min-width: ", ") {\n    margin-top: 0;\n  }\n"], ["\n  margin-top: 29px;\n\n  @media only screen and (min-width: ", ") {\n    margin-top: 0;\n  }\n"])), constants.DIMENSIONS.LARGE);
var ItemsContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject([""], [""])));
var PriceContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  padding: 20px 0;\n  display: grid;\n  gap: 15px;\n  border-bottom: ", ";\n  color: ", ";\n"], ["\n  padding: 20px 0;\n  display: grid;\n  gap: 15px;\n  border-bottom: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledItemQuantityBlock = styled__default(component$j.ItemQuantityBlock)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/19px ", ";\n  color: ", ";\n  margin-bottom: 10px;\n"], ["\n  font: 500 16px/19px ", ";\n  color: ", ";\n  margin-bottom: 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var Title = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  font: 700 20px/24px ", ";\n  color: ", ";\n  margin-bottom: 24px;\n"], ["\n  font: 700 20px/24px ", ";\n  color: ", ";\n  margin-bottom: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var PaymentItemContainer = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

var PriceBlockContainer = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  color: ", ";\n  ", ";\n"], ["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  color: ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var isTotal = _a.isTotal;
    return isTotal && 'margin-top: 10px';
});
var Title$1 = styled__default.div(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  font: 400 16px/19px ", ";\n  color: ", ";\n"], ["\n  font: 400 16px/19px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, isTotal = _a.isTotal;
    return (isTotal ? theme.colors.greys.adminBlack : theme.colors.greys.adminGreyDark);
});
var Price = styled__default.div(templateObject_3$1 || (templateObject_3$1 = tslib_es6.__makeTemplateObject(["\n  font: ", ";\n  color: ", ";\n"], ["\n  font: ",
    ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, isTotal = _a.isTotal;
    return (isTotal
        ? "700 16px/19px " + theme.fonts.join() : "400 16px/19px " + theme.fonts.join());
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
});
var templateObject_1$1, templateObject_2$1, templateObject_3$1;

/* eslint-disable react/require-default-props */
var PriceBlock = function (_a) {
    var title = _a.title, price = _a.price, className = _a.className, _b = _a.isTotal, isTotal = _b === void 0 ? false : _b;
    return (React__default.createElement(PriceBlockContainer, { isTotal: isTotal, className: className },
        React__default.createElement(Title$1, { isTotal: isTotal }, title),
        React__default.createElement(Price, { isTotal: isTotal }, price)));
};

var PaymentDetails = function (_a) {
    var paymentDetailsLabels = _a.paymentDetailsLabels, paymentDetailsValues = _a.paymentDetailsValues, paymentItem = _a.paymentItem, title = _a.title, className = _a.className;
    var itemName = paymentDetailsLabels.itemName, subtotal = paymentDetailsLabels.subtotal, tax = paymentDetailsLabels.tax, credits = paymentDetailsLabels.credits, total = paymentDetailsLabels.total;
    var itemPrice = paymentDetailsValues.itemPrice, subtotalValue = paymentDetailsValues.subtotalValue, taxValue = paymentDetailsValues.taxValue, creditsValue = paymentDetailsValues.creditsValue, totalValue = paymentDetailsValues.totalValue;
    return (React__default.createElement(Container, { "data-testId": "payment-details", className: className },
        React__default.createElement(ItemsContainer, null,
            title && React__default.createElement(Title, null, title),
            React__default.createElement(StyledItemQuantityBlock, { title: itemName, price: itemPrice }),
            paymentItem && React__default.createElement(PaymentItemContainer, null, paymentItem)),
        React__default.createElement(PriceContainer, null,
            React__default.createElement(PriceBlock, { title: subtotal, price: subtotalValue }),
            React__default.createElement(PriceBlock, { title: tax, price: taxValue }),
            !!creditsValue && React__default.createElement(PriceBlock, { title: credits, price: creditsValue }),
            React__default.createElement(PriceBlock, { title: total, price: totalValue, isTotal: true }))));
};

exports.PaymentDetails = PaymentDetails;
